import { useTheme } from '@emotion/react';
import ColoredAvatar from './ColoredAvatar';
import useProfilePicture from './useProfilePicture';
import { type AvatarProps } from '@mui/material';
import { type UserSummary } from '@/lib/types';
import generateColorForName, {
  ColorDerivationStrategy,
} from './generateColorForName';

type UserAvatarProps = Omit<AvatarProps, 'src' | 'children'> & {
  user: UserSummary;
  marginRight?: number;
  size?: number;
};

const UserAvatar = ({ user, size, ...props }: UserAvatarProps) => {
  const profilePicture = useProfilePicture(user);

  const avatarColor = generateColorForName(
    user.name,
    ColorDerivationStrategy.MIDDLE_CHAR,
  );

  const theme = useTheme();
  const avatarColorShade = theme.isDark ? 200 : 600;

  return (
    <ColoredAvatar
      src={profilePicture ?? undefined}
      size={size ?? 40}
      color={avatarColor[avatarColorShade]}
      {...props}
    >
      {user.name.charAt(0)}
    </ColoredAvatar>
  );
};

export default UserAvatar;
